import { blue50 } from '../../../colors/blue';
export var MuiBreadcrumbs = {
    defaultProps: {
        separator: '>',
    },
    styleOverrides: {
        ol: {
            color: blue50,
        },
        li: {
            '& [class*=MuiLink-root]': {
                fontWeight: 'normal',
            },
            '&:last-of-type > *': {
                fontWeight: 500,
            },
        },
    },
};
